<template>
<div class="page">
  <img class="img" src="http://yxfmm.bjyxfl.com/imgs/tg.png" alt="">
</div>
</template>
<script>
export default {
  name: "Notification"
}
</script>


<style scoped lang="less">
.page{
  width: 100%;
  display: flex;
}
</style>